<template>
  <div id="navigationMobile">


    <div class="header-bar">
      <v-btn small flat fab class="menu" @click="toggleMenu">
        <v-icon medium>mdi-menu</v-icon>
      </v-btn>
      <div class="name" v-if="$route.name && app.pages[$route.name]">{{ app.pages[$route.name].title | camelToReadable }}</div>
      <div class="name" v-else-if="app.ready">Page not found</div>
      <v-btn class="link-buttons" flat fab small @click="routeAddQuery('activity')">
        <v-icon medium>mdi-bell</v-icon>
      </v-btn>

      <v-btn class="link-buttons" flat fab small @click="openKnowledgeBase">
        <v-icon medium>mdi-help-circle</v-icon>
      </v-btn>
    </div>
    
    <div class="vo-scrim" :class="{active: $route.query.menu}" @click="toggleMenu"></div>

    <div class="mobile-nav" :class="{active: $route.query.menu}">

      <div class="nav-links">
        <div class="link" v-ripple :class="{selected: isSelected(link)}" v-for="(link, i) in app.navigationMobile" :key="i" @click="updatePage(link, true)" v-if="hasPermissions(link.permissions)">
          <v-icon>{{ link.icon }}</v-icon>
          <div v-if="link" class="name">{{ link.title }}</div>
        </div>
      </div>

      <div class="account" v-ripple @click="updatePage({ route: 'settings' })">
        <vo-avatar class="avatar" :size="30" :user="$store.getters.profile"></vo-avatar>
        <div class="name">{{ $store.getters.profile.fullName }}</div>
      </div>

      <div class="footer-box">
        <div class="logo"></div>
        <div class="links">
          <div class="link" v-for="(link, i) in app.accountNavMobile" @click="optionClicked(link)" :key="i">
            <span v-if="link" class="name">{{ link.title }}</span>
            <span class="pipe" v-if="i < app.accountNavMobile.length - 1">|</span>
          </div>
        </div>
      </div>
    </div>

    <transition name="activity">
      <div v-if="$route.query.activity" class="activity-holder">
        <vo-activity :mobile="true"></vo-activity>
      </div>
    </transition>
    
  </div>
</template>

<script>

  import navMixin         from '../mixins/navMixin.js'
  import permissionMixin  from '../mixins/permissionMixin.js'

  export default {
    mixins: [navMixin, permissionMixin],
    data  () {
      return {

      }
    },
    methods: {
      toggleMenu () {
        if (this.$route.query.menu) this.routeRemoveQuery('menu');
        else this.routeAddQuery('menu', true);
      },

      openKnowledgeBase () {
        window.open(window.urls.knowledgeBase, '_blank');
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';
  @import '../css/transitions.scss';

  #navigationMobile {

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;


    // Activity

    .activity-holder {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background: $white;
      pointer-events: auto;
    }

    .header-bar {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 60px;
      pointer-events: auto;

      .menu {
        position: absolute;
        top: 4px;
        left: 4px;
      }

      .name {
        position: absolute;
        top: 16px;
        left: 70px;
        color: $white;

        @include fontPrimary500();
        font-size: 18px;
        text-transform: uppercase;
        letter-spacing: .5px;
      }

      .link-buttons {
        position: relative;
        float: right;
        top: 4px;
        right: 4px;
        bottom: 0;
        color: $black54;
      }
      
    } // .header-bar

    .mobile-nav {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      width: 280px;
      background: $white;
      box-shadow: 2px 0px 5px 1px rgba(0,0,0,0.24);

      pointer-events: none;
      transform: translate3d(-103%, 0, 0);

      transition: all .3s ease;

      &.active {
        transform: translate3d(0, 0, 0);
        pointer-events: auto;
      }


      .account {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 64px;
        cursor: pointer;
        border-bottom: 2px solid $black12;
        user-select: none;
        
        .avatar {
          position: absolute;;
          top: 17px;
          left: 16px;
        }

        .name {
          @include fontPrimary300();
          @include textEllipsis();

          color: $black87;
          position: absolute;
          left: 64px;
          top: 22px;
          right: 8px;
        }
      
      } // .account

      .nav-links {

        @include scrollable();

        position: absolute;
        top: 64px;
        bottom: 116px;
        left: 0;
        right: 0;
        padding: 8px 0;
        box-sizing: border-box;

        .link {
          @include fontPrimary400();
          
          width: 100%;
          position: relative;
          height: 50px;
          cursor: pointer;
          user-select: none;

          i {
            position: absolute;
            top: 12px;
            left: 12px;
          }

          .name {
            position: absolute;
            left: 60px;
            top: 14px;
          }

          &:hover {
            
            .name {
              color: $primary;
            }

          }

          &.selected {

            i, .name {
              color: $primary;
            }

          }
        }

      } // .nav-links

      .footer-box {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 116px;
        border-top: $borderBlack12;

        .logo {
          margin: 16px 0;
          width: 100%;
          height: 42px;
          background: url('../assets/logos/vilio-black.svg');
          @include backgroundCenter();
        }

        .links {
          width: 100%;
          text-align: center;

          .link {
            display: inline-block;
            color: $primary;

            .name {
              @include fontPrimary400();
              font-size: 12px;
              text-transform: uppercase;
              padding: 3px;
              cursor: pointer;
            }

            .pipe {
              font-size: 12px;
              margin: 0 3px 0 0;
            }
          }
        }
      }

    } // .mobile-nav

  }

</style>



// WEBPACK FOOTER //
// src/components/NavigationMobile.vue